import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Checked = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M7.5 10.75L9.66667 12.9167L14 8.58333M3.16667 1H18.3333C19.53 1 20.5 1.97005 20.5 3.16667V18.3333C20.5 19.53 19.53 20.5 18.3333 20.5H3.16667C1.97005 20.5 1 19.53 1 18.3333V3.16667C1 1.97005 1.97005 1 3.16667 1Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Checked;
